import { createFileRoute } from '@tanstack/react-router'
import { ForgotPassword } from '@/components/ForgotPassword'

export const Route = createFileRoute('/reset-password')({
  component: ResetPasswordComp,
})

function ResetPasswordComp() {
  return <ForgotPassword />
}
